import request from '@/utils/request'
// 图片上传
export function IMGfile(data) {
  return request({
    url: `/attach/fileEnclosure/uploadFile`,
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
    transformRequest: [function(data) {
      return data
    }]
  })
}
// 注册极光
export function Register(data) {
  return request({
    url: `/user/pushRegId`,
    method: 'post',
    data
  })
}
// 获取配置信息
export function initConfig(data) {
  return request({
    url: `/app/appParam/sysParams`,
    method: 'post'
  })
}
// 字典项
export function allDictConfig(data) {
  return request({
    url: `/dictData/selectDictData`,
    method: 'post',
    data
  })
}
// 升级
export function AppUpdata() {
  return request({
    url: `/appVersion/version?appAscription=psys`,
    method: 'get'
  })
}

// 删除图片
export function delImage(data) {
  return request({
    url: `/attach/fileEnclosure/remove`,
    method: 'post',
    data
  })
}

// 理货作业提交
export function tallyAdd(data) {
  return request({
    url: `/tallyDetails/add`,
    method: 'post',
    data
  })
}

// 理货作业时间项查找
export function getWorkSetting(data) {
  return request({
    url: `/workTicket/getWorkSetting`,
    method: 'get',
    data
  })
}

// 理货作业作业要求确定按钮
export function isRead(data) {
  return request({
    url: `/workTicket/isRead`,
    method: 'post',
    data
  })
}

// 根据作业票ID查询对应的机械、班组、海轮、驳船、汽车、火车信息
export function getByTicketId(data) {
  return request({
    url: '/workTicket/getByTicketId',
    method: 'post',
    data
  })
}

// 理货作业查询接口
export function workTicke_list(data) {
  return request({
    url: '/workTicket/list',
    method: 'post',
    data
  })
}

// 船舶调度提交时间
export function shipsaves(data) {
  return request({
    url: '/shipApiDispatch/shipsave',
    method: 'post',
    data
  })
}

// 船舶调度查询接口
export function TowShipByUserId(data) {
  return request({
    url: '/shipApiDispatch/name',
    method: 'post',
    data
  })
}

// 船舶调度泊位选择
export function berthList(data) {
  return request({
    url: '/shipApiDispatch/berthList',
    method: 'post',
    data
  })
}

// 拖轮任务查询
export function TowShip(data) {
  return request({
    url: '/towShip/getTowShipByUserId',
    method: 'post',
    data
  })
}

// 拖轮任务修改状态
export function TowStatus(data) {
  return request({
    url: '/towShip/updateTowStatus',
    method: 'post',
    data
  })
}

// 个人信息修改
export function editUser(data) {
  return request({
    url: '/user/editUser',
    method: 'post',
    data
  })
}

export function editPass(data) {
  return request({
    url: '/user/editPass',
    method: 'post',
    data
  })
}

// 工班统计查询数据
export function worktics(data) {
  return request({
    url: '/tallyDetails/worktics',
    method: 'post',
    data
  })
}

// 整船统计查询数据
export function shipStatistics(data) {
  return request({
    url: '/shipStatistics/list',
    method: 'post',
    data
  })
}

// 整船统计数据详情
export function shipInfo(data) {
  return request({
    url: '/shipStatistics/shipInfo',
    method: 'post',
    data
  })
}
